import { render, staticRenderFns } from "./cell-name.vue?vue&type=template&id=4d68bf45&scoped=true"
import script from "./cell-name.vue?vue&type=script&lang=js"
export * from "./cell-name.vue?vue&type=script&lang=js"
import style0 from "./cell-name.vue?vue&type=style&index=0&id=4d68bf45&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d68bf45",
  null
  
)

export default component.exports